var map = {
	"./decor1.webp": 8160,
	"./decor10.webp": 6872,
	"./decor11.webp": 1115,
	"./decor12.webp": 8474,
	"./decor13.webp": 1829,
	"./decor14.webp": 3972,
	"./decor15.webp": 8007,
	"./decor16.webp": 2390,
	"./decor17.webp": 2145,
	"./decor18.webp": 6704,
	"./decor19.webp": 547,
	"./decor2.webp": 989,
	"./decor20.webp": 4547,
	"./decor21.webp": 1504,
	"./decor22.webp": 5213,
	"./decor23.webp": 3298,
	"./decor24.webp": 1087,
	"./decor25.webp": 2844,
	"./decor26.webp": 2521,
	"./decor27.webp": 1486,
	"./decor3.webp": 6274,
	"./decor4.webp": 5279,
	"./decor5.webp": 396,
	"./decor6.webp": 4665,
	"./decor7.webp": 8638,
	"./decor8.webp": 7595,
	"./decor9.webp": 9224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4649;